<template>
  <div class="pointSetting">
    <el-card>
      <!-- 返回平面图设置 -->
      <div class="jump-btn">
        <el-button type="primary" @click="back()">{{$t('lang.lab_returnPointSetting')}}</el-button>
      </div>
      <el-form :label-width="require('@/config/enum').c_ws5" :label-suffix="require('@/config/enum').c_colon" :inline="true" class="wid100">
        <!-- 平面图名称 -->
        <el-form-item :label="$t('lang.lab_planName')" prop="name" class="width_left60">
          <span>{{ruleForm.name}}</span>
        </el-form-item>
        <el-form-item></el-form-item>
        <!-- 巡检类型 -->
        <el-form-item :label="$t('lang.lab_pointType')" prop="picture" class="width_left">
          <el-radio v-model="radio" :label="item.id" v-for="item in tableData" :key="item.id">{{item.name}}<img :src="require('../../../assets/imgs' + item.url.toString())" width="25px"/></el-radio>
        </el-form-item>
        <el-form-item></el-form-item>
        <!-- 提示文字 -->
        <el-form-item  class="width_left60">
          <span class="blueSpan">{{$t('lang.lab_addPoint')}}</span>
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>
      <!-- 图片加上点位图 -->
      <div ref="imageTofile" id='capture' style="display: inline-block;">
        <div class="positionPoint" :style="'width:' + left + 'px' + ';' + 'height:' + top + 'px' + ';'" @dblclick="add($event)">
          <div v-for='(item, index) in sign' :key='index.pointId'>
            <!-- 悬停的气泡对话框 -->
            <el-popover
              placement="top"
              trigger="hover"
              :title="pointName">
              <p class="height_all">{{item.msg}}</p>
              <div style="text-align: right; margin: 0; bottom: 0;">
                <!-- 编辑点位信息 -->
                <el-button type="primary" size="mini" @click="editPoint(item.pointId, item.msg)">{{$t('lang.btn_modify')}}</el-button>
                <!-- 删除点位信息 -->
                <el-button type="danger" size="mini" @click="delPoint(item.pointId)">{{$t('lang.btn_delete')}}</el-button>
                <!-- 查看二维码 -->
                <el-button type="success" size="mini" @click="seeQrImg(item.pointId, item.msg)">{{$t('lang.lab_seeQrCodes')}}</el-button>
              </div>
              <div :style="'left:' + item.left + ';' + 'top:' + item.top + ';'" class="pointImg" slot="reference">
                <img :src="require('../../../assets/imgs' + item.ptypecss.toString())"/>
              </div>
            </el-popover>
            <div :style="'left:' + item.left + ';' + 'top:' + item.top " class="pointSpan">
              <span>{{item.msg}}</span>
            </div>
          </div>
          <div v-for="(i, index) in sign" :key='index.pointId'>
            <el-popover
              placement="top"
              trigger="hover"
              :title="pointName">
              <p class="height_all">{{i.msg}}</p>
              <div style="text-align: right; margin: 0; bottom: 0;">
                <el-button size="mini" type="primary" @click="editPoint(i.pointId, i.msg)">{{$t('lang.btn_modify')}}</el-button>
                <el-button type="danger" size="mini" @click="delPoint(i.pointId)">{{$t('lang.btn_delete')}}</el-button>
                <el-button type="success" size="mini" @click="seeQrImg(i.pointId, i.msg)">{{$t('lang.lab_seeQrCodes')}}</el-button>
              </div>
              <div :style="'left:' + i.left + ';' + 'top:' + i.top + ';'" class="pointImg" slot="reference">
                <img :src="require('../../../assets/imgs' + i.ptypecss.toString())"/>
              </div>
            </el-popover>
            <div :style="'left:' + i.left + ';' + 'top:' + i.top " class="pointSpan">
              <span>{{ i.msg }}</span>
            </div>
          </div>
        </div>
        <!-- 接口传来的图片 -->
        <img :src="getImgUrl" class="getImg">
      </div>
      <div class="underButtom">
        <!-- 保存点位 -->
        <el-button class="btn-first martop" :disabled="isDisabledpoint" type="primary" @click="savePoint()">{{$t('lang.btn_save')}}</el-button>
        <!-- 点位地图下载 -->
        <el-button @click="setImage" type="success">{{$t('lang.lab_downPoint')}}</el-button>
      </div>
    </el-card>
    <!-- 添加/编辑点位弹框 -->
    <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    center
    top="130px"
    width="600px"
    :title="changeTitle"
    @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" label-width="150px" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lab_pointName')" prop="pointName">
          <el-input v-model="form.pointName" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_pointName')" maxlength="10"></el-input>
          <input style="display: none"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rest('form')">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="addPointInImg('form')">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog
    :visible.sync="showQr"
    :close-on-click-modal="false"
    center
    top="130px"
    width="320px"
    height="320px"
    :title="QrTitle"
    @closed="handleDialogClosed"
    >
      <vue-qr :text="qrText + ''" :title="'{id:' + qrShowPointId +  '}'" :size="300"></vue-qr>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:pointSetting
 *@Description:点位设置
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-20
 */
import html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isDisabledpoint: true, // 是否可点击
      saveDatapoint: '', // 存储json字符串
      saveData: '', // 存储json字符串
      radio: '', // 选择点位样式的单选框
      pointName: this.$i18n.t('lang.lab_pointName'), // 点位名称
      getImgUrl: '', // 获取的图片URL
      id: '', // 传过来的ID
      dataurl: '', // 测试点位图
      tableData: [], // 巡检类型数组
      ruleForm: {
        name: '', // 点位名称
        picture: '' // 点位图
      },
      show: false, // 添加点位的弹框
      isDisabled: false, // 弹框的编辑是否可点击
      showQr: false, // 查看二维码的弹框
      changeTitle: '', // 添加点位弹框的title
      QrTitle: '', // 查看二维码弹框的title
      picName: '', // 下载文件的名称
      qrText: '', // 查看二维码图片左边的名称
      qrShowPointId: '', // 查看二维码显示的内容
      x: 0, // 点击图片后点击位置位于图片的left百分比
      y: 0, // 点击图片后点击位置位于图片的top百分比
      left: 0, // 获取图片的宽度
      top: 0, // 获取图片的高度
      sign: [], // 获取原来图片添加点位的参数数组
      signList: [], // 存储点位在图片上信息的数组
      num: 0, // 新创建点位的初始数量
      trueUrl: '', // 本页转换后的图片
      pointUrl: '', // 选中的点位样式url
      isEdit: 0, // 默认为添加点位，值为1时为编辑点位
      checkPointId: '', // 点击编辑点位后保存的点位ID
      htmlUrl: '',
      form: {
        pointName: ''
      },
      rules: {
        pointName: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_pointName'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    signList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveDatapoint) {
          this.isDisabledpoint = true
        } else {
          this.isDisabledpoint = false
        }
      },
      deep: true,
      immediate: true
    },
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  destroyed() {
    window.localStorage.setItem('pointsaveDatapoint', JSON.stringify(this.saveDatapoint))
    window.localStorage.setItem('pointform', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('pointradio', JSON.stringify(this.radio))
    window.localStorage.setItem('pointsignList', JSON.stringify(this.signList))
  },
  created() {
    this.id = this.$route.query.id
    if (window.localStorage.getItem('pointform')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('pointform'))
      if (window.localStorage.getItem('pointradio')) {
         this.radio = JSON.parse(window.localStorage.getItem('pointradio'))
      }
      if (window.localStorage.getItem('pointsignList')) {
         this.sign = JSON.parse(window.localStorage.getItem('pointsignList'))
      }
      if (window.localStorage.getItem('pointsaveDatapoint')) {
         this.saveDatapoint = JSON.parse(window.localStorage.getItem('pointsaveDatapoint'))
      }
    } else {
      this.getPointList()
    }
    
    this.showImg()
    this.showPoint()
  },
  methods: {
    // 点位地图下载
    setImage() {
      var shareContent = document.querySelector('#capture')
      var width = shareContent.offsetWidth
      var height = shareContent.offsetHeight
      var canvas = document.createElement('canvas')
      var scale = 1
      canvas.width = width * scale
      canvas.height = height * scale
      canvas.getContext('2d').scale(scale, scale)
      var opts = {
        scale: scale,
        canvas: canvas,
        logging: true,
        width: width,
        height: height,
        useCORS: true
      }
      html2canvas(shareContent, opts).then(function (canvas) {
        const imgUrl = canvas.toDataURL('jpg')
        // ie浏览器单独处理
        if (window.navigator.msSaveOrOpenBlob) {
          var bstr = atob(imgUrl.split(',')[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          var blob = new Blob([u8arr])
          window.navigator.msSaveOrOpenBlob(blob, '点位图' + '.' + 'png')
        } else {
          // 这里就按照chrome等新版浏览器来处理
          const a = document.createElement('a')
          a.href = imgUrl
          a.setAttribute('download', '点位图')
          a.click()
        }
      })
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.pointName = ''
      this.$refs.form.clearValidate()
    },
    // 获取所有点位按钮样式
    showPoint() {
      let loading = this.$loading()
      this.$get(`/patrolType?GardenId=${this.gardenId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取本平面图的信息
    showImg() {
      let loading = this.$loading()
      this.$get(`/planarGraphById/${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.ruleForm.name = res.name
            this.picName = res.name
            this.getImgUrl = res.urls[0]
            // 存储图片的宽高
            var img = new Image()
            img.src = this.getImgUrl
            setTimeout(() => {
              this.left = img.width
              this.top = img.height
            }, 0)
            this.getImgUrl = 'data:image/jpg;base64,' + res.dataUrls
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    back() {
      this.$router.push({ name: 'planeLayoutList' })
    },
    // 双击图片
    add(event) {
      // 鼠标在图片上点击了一下，判断巡检类型是否勾选
      if (this.radio != '') {
        this.x = parseFloat(event.offsetX)
        this.y = parseFloat(event.offsetY)
        this.x = Math.round(this.x / this.left * 1000000) / 10000 + '%'
        this.y = Math.round(this.y / this.top * 1000000) / 10000 + '%'
        // 弹出文本框
        this.changeTitle = '输入点位名称'
        this.form.pointName = ''
        this.isEdit = 0
        this.isDisabled = false
        this.show = true
      } else {
        this.$message.error('请先选择巡检类型')
      }
    },
    // 弹框确定创建点位到图片上
    addPointInImg(form) {
      if (this.isEdit === 0) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            for (var i = 0; i < this.tableData.length; i++) {
              if (this.radio === this.tableData[i].id) {
                this.pointUrl = this.tableData[i].url
              }
            }
            this.show = false
            let newPointId = this.guid2()
            this.signList.push({
                msg: this.form.pointName,
                left: this.x,
                top: this.y,
                ptypecss: this.pointUrl,
                pointId: newPointId,
                ptype: this.radio
              })
            return false
          }
        })
      } else {
        this.$refs[form].validate((valid) => {
          if (valid) {
            for (var i = 0; i < this.signList.length; i++) {
              if (this.checkPointId === this.signList[i].pointId) {
                this.signList[i].msg = this.form.pointName
              }
              this.show = false
            }
          } else {
            return false
          }
        })
      }
    },
    // 生成唯一标识符号
    guid2() {
      return new Date().getTime()
    },
    // 删除点位
    delPoint(pointId) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        loading.close()
        for (var i = 0; i < this.signList.length; i++) {
          if (this.signList[i].pointId === pointId) {
            this.signList.splice(i, 1)
          }
        }
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    // 查看二维码
    seeQrImg(pointId, msg) {
      this.QrTitle = this.$i18n.t('lang.lab_seeQrCodes')
      this.qrText = msg
      this.qrShowPointId = pointId
      this.showQr = true
    },
    // 获取图片上的点位信息
    getPointList() {
      let loading = this.$loading()
      this.$get(
        `/patrolPointList?GardenId=${this.gardenId}&PlanarGraphId=${this.id}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            setTimeout(() => {
              this.sign = res.pointJsonArray
              this.signList = res.pointJsonArray
              this.saveDatapoint = JSON.stringify(this.signList)
            }, 1000)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 编辑点位名称
    editPoint(pointId, msg) {
      this.form.pointName = msg
      this.changeTitle = '修改点位名称'
      this.isEdit = 1
      this.checkPointId = pointId
      this.saveData = JSON.stringify(this.form)
      this.show = true
    },
    // 点击保存按钮
    savePoint() {
      if (this.sign.length > 0) {
        let loading = this.$loading()
        let params = {
          GardenId: this.gardenId,
          sign: JSON.stringify(this.signList)
        }
        this.$patch(`/patrolPoint/${this.id}`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.$router.push({ name: 'planeLayoutList' })
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      } else {
        this.$message.error(this.$i18n.t('lang.lab_selOnePlz'))
      }
    },
    // 弹框点击取消
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.pointName = ''
    }
  }
}
</script>

<style lang="scss">
  .pointSetting {
    .martop {
      margin-top: 20px;
      margin-left: 20px;
    }
    overflow: hidden;
    position: relative;
    .blueSpan {
      margin-left: 130px;
      color:#409eff;
    }
    .width_left60 {
      min-width: 75%;
    }
    .width_left {
      max-width: 80%;
      .el-form-item__content {
        max-width: 80%;
      }
    }
    .getImg{
      width: auto;
      height: auto;
      margin-left: 130px;
    }
    .positionPoint {
      position: absolute;
      margin-left: 130px;
    }
    .pointImg {
      cursor: pointer;
      position: absolute;
      margin-left: -25px;
      margin-top: -40px;
      width: 40px;
      height: 50px;
      display: block;
    }
    .pointSpan {
      position: absolute;
      color: #F00;
      width: 150px;
      height: 50px;
      span {
        font-weight: 900;
        font-size: 150%;
        color: #F00;
      }
    }
    .el-radio {
      min-width: 140px;
    }
  }
  .height_all {
    height: 100px;
  }
  .el-popover__title {
    font-weight: 600;
  }
  .orange {
    color: white;
    background-color: #F07157;
    border-color: #F07157;
  }
  .el-popover {
    min-width: 200px !important;
    min-height: 150px !important;
  }
</style>